import { motion } from 'framer-motion';

const BUBBLE = 'M12 2.6a9.4 9.4 0 0 0-8.1 14.2L2.6 21.4l4.7-1.2A9.4 9.4 0 1 0 12 2.6z';
const HANDSET = 'M8.7 7.5c-.3.4-.5 1-.3 1.7.7 2.3 2.5 4.1 4.8 4.9.7.2 1.3 0 1.7-.4l.8-.9a.6.6 0 0 0-.1-.8l-1.6-1a.6.6 0 0 0-.8.2l-.4.5a5 5 0 0 1-2.4-2.4l.5-.4a.6.6 0 0 0 .2-.8l-1-1.6a.6.6 0 0 0-.8-.1z';

/**
 * Icono de WhatsApp propio (burbuja + auricular) en dorado GT Race.
 * Se dibuja al aparecer y el auricular "suena" de forma suave.
 */
export default function AnimatedWhatsApp({ className = 'w-6 h-6', color = '#D4AF37' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <motion.path
        d={BUBBLE}
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0, opacity: 0.4 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 1.4, ease: 'easeInOut' }}
      />
      <motion.path
        d={HANDSET}
        fill={color}
        style={{ transformOrigin: '12px 12px' }}
        animate={{ rotate: [0, -12, 10, -8, 6, 0], scale: [1, 1.06, 1] }}
        transition={{ duration: 1.1, repeat: Infinity, repeatDelay: 2.6, ease: 'easeInOut' }}
      />
      {[0, 1].map((i) => (
        <motion.path
          key={i}
          d={i === 0 ? 'M15.6 6.6a4 4 0 0 1 1.9 1.9' : 'M16 4.4a6.4 6.4 0 0 1 3.6 3.6'}
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          animate={{ opacity: [0, 1, 0] }}
          transition={{ duration: 1.1, repeat: Infinity, repeatDelay: 2.6, delay: 0.15 * i }}
        />
      ))}
    </svg>
  );
}
